import { LogicRulesNames, notLogicRule, RuleGroupNames } from '@candu-ai/segments/types';

export const booleanOptions = [
  {
    label: 'Pick an option',
    default: true,
    value: '',
    disabled: true,
    selected: true,
  },
  {
    label: 'true',
    value: 'true',
  },
  {
    label: 'false',
    value: 'false',
  },
];

export const segmentTypeOptions = [
  {
    label: 'User ID',
    value: 'UserId',
  },
  {
    label: 'User Property',
    value: 'UserProperty',
  },
  {
    label: 'First visit',
    value: 'FirstSeen',
  },
  {
    label: 'Last visit',
    value: 'LastSeen',
    deprecated: true,
  },
  {
    label: 'Schedule Content',
    value: 'LimitedTimeContent',
  },
  {
    label: 'User Event',
    value: 'EventOccurred',
  },
  {
    label: 'Segment',
    value: 'ISR',
  },
];

export const limitedTimeContentOptions = [
  {
    label: 'Show after',
    value: LogicRulesNames.GTEQ,
  },
  {
    label: 'Show until',
    value: LogicRulesNames.LTEQ,
  },
];

export const segmentUserSeenOptions = [
  {
    label: 'Occurred in the last',
    value: 'relative',
  },
  {
    label: 'Not occurred in the last',
    value: 'not_relative',
  },
  {
    label: 'Occurred after',
    value: 'absolute',
  },
  {
    label: 'Not occurred after',
    value: 'not_absolute',
  },
];

export const eventOccurredOptions = [
  {
    label: 'Has occurred',
    value: 'infinite',
  },
  {
    label: 'Has not occurred',
    value: 'not_infinite',
  },
  ...segmentUserSeenOptions,
];

// Provide an autocomplete field in the segment builder for these operands
export const autoCompleteStringOperands = [
  LogicRulesNames.Equals,
  notLogicRule(LogicRulesNames.Equals),
  LogicRulesNames.Exists,
  notLogicRule(LogicRulesNames.Exists),
  LogicRulesNames.Contains,
  notLogicRule(LogicRulesNames.Contains),
  LogicRulesNames.StringExists,
  notLogicRule(LogicRulesNames.StringExists),
];

export const multiselectStringOperands = [
  LogicRulesNames.Contains,
  notLogicRule(LogicRulesNames.Contains),
];

export const emptySingleRuleGroup = {
  object: RuleGroupNames.Single,
  type: '',
  operation: {
    operand: '',
    type: '',
  },
};

export const isDefinedOptions = [
  {
    label: 'Exists',
    value: LogicRulesNames.Exists,
  },
  {
    label: 'Does not exist',
    value: notLogicRule(LogicRulesNames.Exists),
  },
];

export const isStringDefinedOptions = [
  {
    label: 'Exists',
    value: LogicRulesNames.StringExists,
  },
  {
    label: 'Does not exist',
    value: notLogicRule(LogicRulesNames.StringExists),
  },
];

export const numberOperations = [
  {
    label: 'Equal to',
    value: LogicRulesNames.Equals,
  },
  {
    label: 'Greater or equal to',
    value: LogicRulesNames.GTEQ,
  },
  {
    label: 'Greater than',
    value: LogicRulesNames.GT,
  },
  {
    label: 'Less than',
    value: LogicRulesNames.LT,
  },
  {
    label: 'Less or equal to',
    value: LogicRulesNames.LTEQ,
  },
  ...isDefinedOptions,
];

export const datesOperations = [
  {
    label: 'Equal to',
    value: LogicRulesNames.Equals,
  },
  {
    label: 'After or equal to',
    value: LogicRulesNames.GTEQ,
  },
  {
    label: 'After',
    value: LogicRulesNames.GT,
  },
  {
    label: 'Before than',
    value: LogicRulesNames.LT,
  },
  {
    label: 'Before or equal to',
    value: LogicRulesNames.LTEQ,
  },
  {
    label: 'Occurred in the last',
    value: LogicRulesNames.Within,
  },
  {
    label: 'Not occurred in the last',
    value: LogicRulesNames.Outside,
  },
  ...isDefinedOptions,
];

export const defaultOperations = [
  {
    label: 'Is one of',
    value: LogicRulesNames.Contains,
  },
  {
    label: 'Is not one of',
    value: notLogicRule(LogicRulesNames.Contains),
  },
  {
    label: 'Equal to',
    value: LogicRulesNames.Equals,
  },
  {
    label: 'Not equal to',
    value: notLogicRule(LogicRulesNames.Equals),
  },
  {
    label: 'Contains',
    value: LogicRulesNames.Substring,
  },
  {
    label: 'Does not contain',
    value: notLogicRule(LogicRulesNames.Substring),
  },
  {
    label: 'Ends with',
    value: LogicRulesNames.EndsWith,
  },
  {
    label: 'Does not end with',
    value: notLogicRule(LogicRulesNames.EndsWith),
  },
  {
    label: 'Starts with',
    value: LogicRulesNames.StartsWith,
  },
  {
    label: 'Does not start with',
    value: notLogicRule(LogicRulesNames.StartsWith),
  },
];

export const stringOperations = [...defaultOperations, ...isStringDefinedOptions];

export const booleanOperations = [
  {
    label: 'Equal to',
    value: LogicRulesNames.Equals,
  },
  ...isDefinedOptions,
];
